import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPriceLists, editPriceList } from 'modules/categories/categoriesSlice';
// eslint-disable-next-line max-len
import ScansPriceListsComponent from 'modules/categories/scans/components/ScansPriceListsComponent';
import { status, searchQueryMinLength } from 'constants/general';
import { CategoryEnum } from 'constants/categories';
import { useParams } from 'react-router-dom';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ScansPriceListsContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    healthPlanId,
    categoryId: CategoryEnum.Scans,
    pageNumber: 1,
    pagesize: 10,
  };
  const [priceListsQueryString, setPriceListsQueryString] = useState(InitialQueryString);
  const [isCreatePriceListModalHidden, setIsCreatePriceListModalHidden] = useState(true);
  const [priceListInfo, setPriceListInfo] = useState();

  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const submitPriceListState = useSelector(state => state.categories.submitPriceList);
  const editPriceListState = useSelector(state => state.categories.editPriceList);
  const prevSubmitPriceListStateStatus = useDeferredValue(submitPriceListState.status);
  const prevEditPriceListStateStatus = useDeferredValue(editPriceListState.status);
  useEffect(() => {
    if (
      (status.SUCCESS === submitPriceListState.status &&
        prevSubmitPriceListStateStatus !== submitPriceListState.status) ||
      (status.SUCCESS === editPriceListState.status &&
        editPriceListState.status !== prevEditPriceListStateStatus)
    ) {
      setPriceListsQueryString({ ...InitialQueryString });
    }
  }, [submitPriceListState.status, editPriceListState.status]);

  useEffect(() => {
    dispatch(fetchPriceLists(priceListsQueryString));
  }, [dispatch, priceListsQueryString]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################

  const handleInputFieldChange = () => {};

  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...priceListsQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchTerm = searchTerm;
    if (reset) delete queryString.searchTerm;

    setPriceListsQueryString(queryString);
  };

  const handleSubmitPriceList = () => {};

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && priceListsQueryString.searchTerm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...priceListsQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setPriceListsQueryString(data);
  };

  const handlePriceListEdit = rowDataPayload => {
    setPriceListInfo(rowDataPayload);
    setIsCreatePriceListModalHidden(false);
  };

  const handlePriceListDeactivate = rowDataPayload => {
    const { id, name, active } = rowDataPayload;
    const payload = {
      id,
      data: {
        healthPlanId,
        name,
        active: !active,
      },
    };
    dispatch(editPriceList(payload));
  };

  const handleCancelPriceList = () => {};

  const flushPriceListInfo = () => setPriceListInfo(undefined);
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <ScansPriceListsComponent
      isCreatePriceListModalHidden={isCreatePriceListModalHidden}
      setIsCreatePriceListModalHidden={setIsCreatePriceListModalHidden}
      handleSubmitPriceList={handleSubmitPriceList}
      handleInputFieldChange={handleInputFieldChange}
      searchQuery={searchQuery}
      handleSearchBarInputChange={handleSearchBarInputChange}
      priceListsQueryString={priceListsQueryString}
      handleShowMoreClick={handleShowMoreClick}
      handlePriceListEdit={handlePriceListEdit}
      handleCancelPriceList={handleCancelPriceList}
      handlePriceListDeactivate={handlePriceListDeactivate}
      healthPlanId={healthPlanId}
      selectedPriceListInfo={priceListInfo}
      flushPriceListInfo={flushPriceListInfo}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ScansPriceListsContainer.propTypes = {};

ScansPriceListsContainer.defaultProps = {};

export default ScansPriceListsContainer;
